/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelAllResponse
 */
export interface CancelAllResponse {
  /**
   *
   * @type {number}
   * @memberof CancelAllResponse
   */
  cancelledCount: number;
}

/**
 * Check if a given object implements the CancelAllResponse interface.
 */
export function instanceOfCancelAllResponse(
  value: object,
): value is CancelAllResponse {
  if (!("cancelledCount" in value) || value["cancelledCount"] === undefined)
    return false;
  return true;
}

export function CancelAllResponseFromJSON(json: any): CancelAllResponse {
  return CancelAllResponseFromJSONTyped(json, false);
}

export function CancelAllResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelAllResponse {
  if (json == null) {
    return json;
  }
  return {
    cancelledCount: json["cancelledCount"],
  };
}

export function CancelAllResponseToJSON(json: any): CancelAllResponse {
  return CancelAllResponseToJSONTyped(json, false);
}

export function CancelAllResponseToJSONTyped(
  value?: CancelAllResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cancelledCount: value["cancelledCount"],
  };
}
